export default function HowToApply() {
  const steps = [
    {
      number: '1',
      title: '公式サイトから申込み',
      description: '公式サイトの申込みフォームから必要事項を入力。本人確認書類の画像をアップロードします。',
      icon: 'ri-file-text-line'
    },
    {
      number: '2',
      title: '審査',
      description: '入力内容をもとに審査が行われます。通常、数日から1週間程度で審査結果がメールで通知されます。',
      icon: 'ri-search-eye-line'
    },
    {
      number: '3',
      title: 'カード発行・受取',
      description: '審査通過後、カードが発行され自宅に郵送されます。受取時に本人確認が必要な場合があります。',
      icon: 'ri-bank-card-line'
    },
    {
      number: '4',
      title: '利用開始',
      description: 'カード受取後、すぐに利用開始できます。会員専用サイトでポイント確認や各種設定が可能です。',
      icon: 'ri-check-double-line'
    }
  ];

  const requirements = [
    { icon: 'ri-user-line', text: '18歳以上（高校生を除く）' },
    { icon: 'ri-mail-line', text: 'メールアドレス' },
    { icon: 'ri-phone-line', text: '携帯電話番号' },
    { icon: 'ri-bank-line', text: '本人名義の銀行口座' },
    { icon: 'ri-id-card-line', text: '本人確認書類（運転免許証など）' }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-orange-50 via-white to-red-50">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-4">
          申込み方法
        </h2>
        <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
          オンラインで簡単に申込みができます。最短1週間で発行可能です
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 h-full">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-red-500 rounded-full flex items-center justify-center text-white font-bold text-xl flex-shrink-0">
                    {step.number}
                  </div>
                  <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${step.icon} text-orange-600 text-xl w-6 h-6 flex items-center justify-center`}></i>
                  </div>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-orange-400 text-2xl w-6 h-6 flex items-center justify-center"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            申込みに必要なもの
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
            {requirements.map((req, index) => (
              <div
                key={index}
                className="flex items-center gap-3 bg-gradient-to-r from-orange-50 to-red-50 rounded-lg p-4 border border-orange-200"
              >
                <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className={`${req.icon} text-white text-lg w-6 h-6 flex items-center justify-center`}></i>
                </div>
                <span className="text-gray-900 font-semibold">{req.text}</span>
              </div>
            ))}
          </div>

          <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-xl p-6 border border-orange-200">
            <div className="flex items-start gap-3">
              <i className="ri-information-line text-orange-600 text-xl mt-1 w-6 h-6 flex items-center justify-center flex-shrink-0"></i>
              <div>
                <h4 className="font-bold text-gray-900 mb-2">申込み時の注意点</h4>
                <ul className="text-sm text-gray-700 space-y-2">
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-orange-500 mt-0.5 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                    <span>申込み時に会員専用サイトのアカウント登録が必要です</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-orange-500 mt-0.5 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                    <span>本人確認書類は鮮明な画像をアップロードしてください</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-orange-500 mt-0.5 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                    <span>引落し口座の設定は、オンラインまたは郵送で行います</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-orange-500 mt-0.5 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                    <span>キャンペーン特典を受けるには、指定期間内の利用が必要です</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 text-center">
          <a
            href="https://px.a8.net/svt/ejp?a8mat=4AXB0E+3PYKNU+4T5W+5YRHE"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-block bg-gradient-to-r from-orange-500 to-red-500 text-white font-bold text-lg px-10 py-5 rounded-xl hover:from-orange-600 hover:to-red-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            公式サイトで申込む
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
